import { jsxs as r, jsx as a } from "react/jsx-runtime";
import { c as y } from "../clsx-OuTLNxxd.js";
import I from "react";
import { PromoBadges as b } from "../PromoBadges/PromoBadges.js";
import { s as e } from "../HorizontalSuiteCardBase.module-CNVqr36m.js";
import { R as B } from "../ResponsiveSanityImage-BfPbiFwC.js";
import { PriceItem as x } from "../Prices/PriceItem/PriceItem.js";
import { i as C } from "../utils-NCUO6j8v.js";
const H = _ref => {
  let {
    image: s,
    title: c,
    subtitle: o,
    trackingName: n,
    className: p,
    features: h,
    actionButton: f,
    detailsButton: u,
    imageFooterComponent: N,
    variant: m = "default",
    prices: g,
    pricesDisclaimer: t,
    featuresSectionTitle: v,
    activePromos: d = []
  } = _ref;
  return /* @__PURE__ */r("article", {
    className: y(e.card, p, {
      [e.cardSelected]: m == "selected",
      [e.cardBlurred]: m == "blurred"
    }),
    "data-content-name": n,
    children: [C(s) && /* @__PURE__ */r("div", {
      className: e.image,
      children: [/* @__PURE__ */a(B, {
        image: s,
        defaultWidth: 400,
        defaultHeight: 300,
        draggable: !1,
        loading: "lazy",
        className: e.imageInner,
        alt: c
      }), /* @__PURE__ */a("div", {
        className: e.imageFooter,
        children: N
      })]
    }), /* @__PURE__ */r("div", {
      className: e.title,
      children: [c, o, d.length > 0 ? /* @__PURE__ */a(b, {
        promos: d,
        className: e.promoBox,
        variant: "small"
      }) : null]
    }), /* @__PURE__ */r("div", {
      className: e.features,
      children: [/* @__PURE__ */a("div", {
        className: e.columnTitle,
        children: v
      }), /* @__PURE__ */a("ul", {
        children: h.map((l, i) => /* @__PURE__ */a("li", {
          children: l
        }, i))
      })]
    }), /* @__PURE__ */r("div", {
      className: e.pricesColumn,
      children: [t && /* @__PURE__ */a("div", {
        className: e.columnTitle,
        children: t
      }), /* @__PURE__ */a("div", {
        className: e.prices,
        children: g.map((l, i) => /* @__PURE__ */r(I.Fragment, {
          children: [i == 0 ? null : /* @__PURE__ */a("hr", {}), /* @__PURE__ */r("div", {
            className: e.priceItemWrapper,
            children: [/* @__PURE__ */a("div", {
              className: e.fareLabel,
              children: l.fareLabel
            }), /* @__PURE__ */a(x, {
              className: e.priceItem,
              priceClassName: e.priceItemInner,
              layout: "column",
              showFareLabel: !1,
              chipBackgroundColor: "white",
              price: l,
              variant: "normal",
              priceType: i == 0 ? "primary" : "secondary"
            })]
          })]
        }, l.fareLabel))
      })]
    }), /* @__PURE__ */r("div", {
      className: e.footer,
      children: [u, " ", f]
    })]
  });
};
export { H as HorizontalSuiteCardBase };